import React from 'react'
import FetchData from '../../../shared/fetchData'
import './LockerReports.css'
import ReactPaginate from 'react-paginate'
import Search from '../../../components/UI/Search/Search'
import DatePicker from '../../../components/UI/DatePicker/DatePicker'
import Button from '../../../components/UI/Button/Button'
import { updateObject } from '../../../shared/utility'
import Input from '../../../components/UI/Input/Input'
import Modal from '../../../components/UI/Modal/Modal'
import Select from '../../../components/UI/Select/Select'
import * as FileSaver from "file-saver"
import * as XLSX from "xlsx"

const LockerReports = (props) => {

    const [from, setFrom] = React.useState('')
    const [to, setTo] = React.useState('')
    const [lockerReports, setLockerReports] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [invoiceReportInfo, setInvoiceReportInfo] = React.useState('')
    const [kiosks, setKiosks] = React.useState([])
    const [kiosk, setKiosk] = React.useState('')
    const [isActive, setIsActive] = React.useState('')
    const [statusList, setStatusList] = React.useState([
        {
            value: "1",
            label: "فعال",
        },
        {
            value: "0",
            label: "غير فعال",
        }
    ])

    React.useEffect(() => {
        var raw = JSON.stringify({
            "kiosk": {
            },
            "pl": "1048576",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/kiosks/getKiosks'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setKiosks(result.kiosks);
            })
            .catch(error => setLoading(false))
    }, [])

    const exportToCSV = (event) => {
        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({
            "kiosk": {
                "fromDate": from != null && from != '' ? from : null,
                "toDate": to != null && to != '' ? to : null,
                "kioskId": kiosk != null && kiosk != '' ? kiosk.value : null,
                "isActive": isActive != null && isActive != "" ? isActive.value : null,
            },
            "pl": "1048576",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/kiosks/getKiosksReport'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    let exportInvoiceReport = []
                    let count = 0
                    const report = result.kiosks.map(o => {
                        count++
                        exportInvoiceReport.push({
                            'ردیف': count,
                            'نام لاکر': o.description,
                            'آدرس لاکر(فارسی)': o.address,
                            'آدرس لاکر(انگلیسی)': o.addressEn,
                            'نوع لاکر': o.kioskType?.description,
                            'موقعیت جغرافیایی لاکر(عرض جغرافیایی)': o.lat,
                            'موقعیت جغرافیایی لاکر(طول جغرافیایی)': o.lon,
                            'وضعيت': o.isActive != null && o.isActive == "1" ? 'فعال است' : 'فعال نيست',
                            'تاريخ و ساعت تغيير وضعيت': (o.doorStateDate != null ? o.doorStateDate : '') + '-' + (o.doorStateTime != null ? o.doorStateTime : ''),
                        })
                    })
                    const fileType =
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const fileExtension = ".xlsx";
                    const ws = XLSX.utils.json_to_sheet(exportInvoiceReport);
                    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const data = new Blob([excelBuffer], { type: fileType });
                    FileSaver.saveAs(data, 'LockerReports' + fileExtension)
                }
            })
            .catch(error => setLoading(false))
    }
    const changeFromDate = (unix, formatted) => {
        setFrom(formatted)
    }
    const changeToDate = (unix, formatted) => {
        setTo(formatted)
    }
    const changeKiosk = selectedOption => {
        setKiosk(selectedOption)
    }
    const changeStatus = selectedOption => {
        setIsActive(selectedOption)
    }
    const refresh = (event) => {
        setFrom('')
        setTo('')
        setKiosk('')
        setIsActive('')
    }
    const kioskList = []
    if (kiosks != null && kiosks.length != 0) {
        kiosks.map(z => {
            kioskList.push({
                value: z.id,
                label: z.description
            })
        })
    }
    let form = <div>
        <div className="row pl-4" dir="ltr">
        </div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            <div className="col-3 swipeable small-ord-col">
                <DatePicker change={changeFromDate} value={from} placeHolder="از تاریخ" />
            </div>
            <div className="col-3 swipeable small-ord-col">
                <DatePicker change={changeToDate} value={to} placeHolder="تا تاریخ" />
            </div>
            <Select
                name="form-field-name"
                value={isActive}
                placeholder="وضعيت"
                options={statusList}
                onChange={changeStatus}
                col="3"
            />
            <Select
                name="form-field-name"
                value={kiosk}
                placeholder="لاکر"
                options={kioskList}
                onChange={changeKiosk}
                col="3"
            />
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-6 text-left ord-small-btns">
                <Button btnType="Search" clicked={exportToCSV}>
                    <span className="tab-color">
                        گزارشگیری
                    </span>
                </Button>
            </div>
        </div>
    </div>
    return (
        <div className="third-lockerReports">
            <Search class="invoices-search" form={form} />
        </div>
    )
}
export default LockerReports